import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15601f59"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "acs-acsi-price" }
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "acs-acsi-price-label" }, "ACS:  ", -1))
const _hoisted_4 = { class: "acs-acsi-price-value" }
const _hoisted_5 = ["title"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "acs-acsi-price-label" }, "ACSI: ", -1))
const _hoisted_7 = { class: "acs-acsi-price-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      title: _ctx.acsStats.acsSupply ? `Supply: $${_ctx.acsStats.acsSupply}` : '--'
    }, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.acsStats.acsiPriceUsd
          ? `$${_ctx.acsStats.acsPriceUsd} (${_ctx.acsStats.acsPriceBNB} BNB)`
          : '--'), 1)
    ], 8, _hoisted_2),
    _createElementVNode("div", {
      title: _ctx.acsStats.acsiSupply ? `Supply: $${_ctx.acsStats.acsiSupply}` : '--'
    }, [
      _hoisted_6,
      _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.acsStats.acsiPriceUsd
          ? `$${_ctx.acsStats.acsiPriceUsd} (${_ctx.acsStats.acsiPriceBNB} BNB)`
          : '--'), 1)
    ], 8, _hoisted_5)
  ]))
}